const { reduce, replace } = require('lodash');

class DigitalPayErrorMessageGenerator {
    constructor(settings) {
        this.settings = settings;
    }

    getCreditCardDialogSubmitIframeError(errorCode) {
        if (errorCode === this.settings.digitalPayErrorCodes.creditCardCaptureFormExpired) {
            return this.settings.digitalPayError.creditCardDialogCvvExpiredMessage;
        }

        return this.isSplitPayment
            ? this.settings.digitalPayError.genericGlobalSplitPaymentMessage
            : this.settings.digitalPayError.genericGlobalPaymentMessage;
    }

    getGiftCardTokenizeError(errorCode, giftCardSuffix = '') {
        switch (errorCode) {
            case this.settings.digitalPayErrorCodes.giftCardNotAcceptedByBanner:
                return this.settings.digitalPayError.giftCardPaymentNotAcceptedByBannerErrorMessage;
            case this.settings.digitalPayErrorCodes.giftCardUnableToRetrieveDetails:
                return this.settings.digitalPayError.giftCardIncorrectDetailsMessage;
            case this.settings.digitalPayErrorCodes.paymentInstrumentExpired:
                return this.settings.digitalPayError.giftCardAddExpiredMessage;
            case this.settings.digitalPayErrorCodes.giftCardZeroBalance:
                return this.settings.digitalPayError.giftCardAddInsufficientFundsMessage;
            default:
                return this.isSplitPayment
                    ? this.formatErrorMessage(this.settings.digitalPayError.giftCardGenericSplitPaymentErrorMessageTemplate, [giftCardSuffix])
                    : this.formatErrorMessage(this.settings.digitalPayError.giftCardGenericPaymentErrorMessageTemplate, [giftCardSuffix]);
        }
    }

    getGiftCardPaymentError(errorCode, giftCardSuffix, paymentResponseErrorMessage = '') {
        switch (errorCode) {
            case this.settings.digitalPayErrorCodes.unknownPayment:
                return this.isSplitPayment
                    ? this.formatErrorMessage(this.settings.digitalPayError.giftCardGenericSplitPaymentErrorMessageTemplate, [giftCardSuffix])
                    : this.formatErrorMessage(this.settings.digitalPayError.giftCardGenericPaymentErrorMessageTemplate, [giftCardSuffix]);
            default:
                return this.isSplitPayment
                    ? this.formatErrorMessage(this.settings.digitalPayError.giftCardSpecificSplitPaymentErrorMessageTemplate, [giftCardSuffix, paymentResponseErrorMessage.toLowerCase()])
                    : this.formatErrorMessage(this.settings.digitalPayError.giftCardSpecificPaymentErrorMessageTemplate, [giftCardSuffix, paymentResponseErrorMessage.toLowerCase()]);
        }
    }

    getPaypalLinkError(errorCode) {
        switch (errorCode) {
            case this.settings.digitalPayErrorCodes.paypalAccountLockedOrClosed:
                return this.settings.digitalPayError.paypalPaymentUnregisteredExternallyErrorMessage;
            default:
                return this.settings.digitalPayError.paypalLinkFailureErrorMessage;
        }
    }

    getPaypalUnlinkError(errorCode) {
        switch (errorCode) {
            case this.settings.digitalPayErrorCodes.paypalAccountLockedOrClosed:
                return this.settings.digitalPayError.paypalPaymentUnregisteredExternallyErrorMessage;
            default:
                return this.settings.digitalPayError.paypalUnlinkFailureErrorMessage;
        }
    }

    getPaypalPaymentError(errorCode) {
        switch (errorCode) {
            case this.settings.digitalPayErrorCodes.paypalAccountLockedOrClosed:
                return this.settings.digitalPayError.paypalPaymentUnregisteredExternallyErrorMessage;
            case this.settings.digitalPayErrorCodes.insufficientFunds:
                return this.settings.digitalPayError.paypalInsufficientFundsMessage;
            case this.settings.digitalPayErrorCodes.paymentInstrumentNotFound:
                return this.isSplitPayment
                    ? this.settings.digitalPayError.paymentInstrumentNotFoundSplitPaymentMessage
                    : this.settings.digitalPayError.paymentInstrumentNotFoundMessage;
            default:
                return this.isSplitPayment
                    ? this.settings.digitalPayError.paypalSplitPaymentGenericErrorMessage
                    : this.settings.digitalPayError.paypalPaymentGenericErrorMessage;
        }
    }

    getNewCreditCardPaymentError(isSavingCard) {
        if (this.isSplitPayment) {
            return isSavingCard
                ? this.settings.digitalPayError.creditCardSplitPaymentSaveNewCreditCardFailure
                : this.settings.digitalPayError.creditCardSplitPaymentNewCreditCardFailure;
        }

        return isSavingCard
            ? this.settings.digitalPayError.creditCardPaymentSaveNewCreditCardFailure
            : this.settings.digitalPayError.creditCardPaymentNewCreditCardFailure;
    }

    getGenericPaymentError(errorCode) {
        switch (errorCode) {
            case this.settings.digitalPayErrorCodes.paymentInstrumentNotFound:
                return this.isSplitPayment
                    ? this.settings.digitalPayError.paymentInstrumentNotFoundSplitPaymentMessage
                    : this.settings.digitalPayError.paymentInstrumentNotFoundMessage;
            default:
                return this.isSplitPayment
                    ? this.settings.digitalPayError.genericGlobalSplitPaymentMessage
                    : this.settings.digitalPayError.genericGlobalPaymentMessage;
        }
    }

    /**
     * Formats string template by replacing {\*} placeholders. Where * is the index number of the content to be replaced.
     * @param {string} template
     * @param {string[]} content
     */
    formatErrorMessage(template, ...content) {
        return reduce(...content, (result, value, index) => replace(result, `{${index}}`, value), template);
    }

    getPaymentErrorMode() {
        return this.isSplitPayment;
    }

    setPaymentErrorMode(isSplitPayment) {
        this.isSplitPayment = isSplitPayment;
    }
}

module.exports = DigitalPayErrorMessageGenerator;



// WEBPACK FOOTER //
// ./src/wallet/error/digital-pay-error-message.generator.js